import { classNames } from 'primereact/utils';
import {
  AutoCompleteContext,
  AutoCompletePassThroughOptions,
  AutoCompleteProps,
} from 'primereact/autocomplete';

export const PTAutoComplete: AutoCompletePassThroughOptions = {
  root: ({ props }: { props: AutoCompleteProps }) => ({
    className: classNames(
      'relative inline-flex',
      {
        'opacity-60 select-none pointer-events-none cursor-default':
          props.disabled,
      },
      { 'w-full': props.multiple },
    ),
  }),
  container: {
    className: classNames(
      'm-0 list-none cursor-text overflow-hidden flex items-center flex-wrap w-full',
      'px-3 py-2 gap-2',
      'font-sans text-base text-gray-700 dark:text-white/80 bg-white dark:bg-gray-900 border border-gray-300 dark:border-blue-900/40  transition duration-200 ease-in-out appearance-none rounded-md',
      'focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] hover:border-blue-500 focus:outline-none dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
    ),
  },
  inputToken: {
    className: classNames('py-0.375rem px-0', 'flex-1 inline-flex'),
  },
  token: {
    className: classNames(
      'py-1 px-2 mr-2 bg-gray-300 text-gray-700 dark:text-white/80 rounded-full',
      'cursor-default inline-flex items-center',
    ),
  },
  panel: {
    className: classNames(
      'bg-white text-gray-700 border-0 rounded-md shadow-lg z-1101',
      'max-h-[200px] overflow-auto',
    ),
  },
  list: {
    className: 'py-3 px-2! list-none m-0 z-1101',
  },
  item: ({ context }: { context: AutoCompleteContext }) => ({
    className: classNames(
      'cursor-pointer font-normal overflow-hidden relative whitespace-nowrap',
      'm-0 p-1 border-0  transition-shadow duration-200 rounded-xl',
      {
        'text-teal hover:text-teal hover:bg-gray-100': !context.selected,
        'text-teal dark:text-white/80 hover:text-teal hover:bg-gray-100':
          !context.selected,
        'bg-blue-100 text-blue-700': context.selected,
        'bg-blue-50 text-blue-700': context.selected,
      },
    ),
  }),
  itemGroup: {
    className: classNames(
      'm-0 p-3 text-gray-800 bg-white font-bold',
      'cursor-auto',
    ),
  },
  loadingIcon: {
    className: 'absolute top-3 right-2 animate-spin',
  },
  transition: {
    timeout: 150,
    classNames: {
      enter: 'opacity-0 scale-75',
      enterActive:
        'opacity-100 !scale-100 transition-transform transition-opacity duration-150 ease-in',
      exit: 'opacity-100',
      exitActive: '!opacity-0 transition-opacity duration-150 ease-linear',
    },
  },
};
